<app-progress-indicator [inProgress]="isLoading"></app-progress-indicator>
<app-tabnav [goBackLink]="true"></app-tabnav>
<div *ngIf="selectedVorhersage" class="wetter_content_container">
  <h3 style="margin:auto">{{selectedVorhersage?.ort?.name}}</h3>
  <span class="wetter_detail_subtitle">{{selectedVorhersage?.ort?.bundesLand}}
    - {{selectedVorhersage?.ort?.landKreis}}</span>
  <app-24h-vorhersage-table [vorhersageTage]="selectedVorhersage.getTagesListe()"></app-24h-vorhersage-table>
</div>
